
import { i18nText } from '@/locales';
import {Form} from "@/form/form";
import {Validate} from "@/plugins/Vuelidate/Decorators";
import {numeric, required, requiredIf} from "vuelidate/lib/validators";
import {Component} from "vue-property-decorator";
import {PaymentArticlesAddFormRequestType} from "@/form/finance/payment_articles/PaymentArticlesAddForm.types";
import {IPaymentArticlesType, PaymentArticlesTypeResponseType} from "@/entity/finance/payment_articles/paymentArticlesType.types";
import { fio, email } from "@/utils/validators";

@Component
export default class PaymentArticlesAddForm extends Form{
    @Validate(required, i18nText("Введите название"))
    name = '';
    @Validate(required, i18nText("Выберите тип"))
    type_id = 0;
    comment = null;
    salon_id = 0;
    types: IPaymentArticlesType[] | null = [
        {id: 1, name: i18nText("Доходы")},
        {id: 2, name: i18nText("Расходы на себестоимость")},
        {id: 3, name: i18nText("Коммерческие расходы")},
        {id: 4, name: i18nText("Расходы на персонал")},
    ]
    getFormData(): PaymentArticlesAddFormRequestType {
        return {
            name: this.name,
            type_id: this.type_id,
            comment: this.comment,
            salon_id: this.salon_id
        }
    }
    setFormData(types: IPaymentArticlesType[]): void {
      /*  this.types = [];
        for (let i = 0; i < types.length; i++) {
            if(!this.type_id){
                this.type_id = types[i].id;
            }
            this.types.push(types[i]);
        }*/
    }
}
